/****  Delivery estimation js pdp    *****/

document.addEventListener('DOMContentLoaded', () => {
    const heading = document.querySelector('.clickpost-edd__heading');
    const form = document.querySelector('.clickpost-edd__form');
  
    heading.addEventListener('click', () => {
      form.classList.toggle('show');
    });
  });


/**** Popup    *****/
  // Function to show a specific popup
  function showPopup(popupId) {
    document.getElementById(popupId).style.display = 'block';
  }

  // Function to close a specific popup
  function closePopup(popupId) {
    document.getElementById(popupId).style.display = 'none';
  }
